var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "navbar" },
    [
      _c(
        _vm.$mq === "mobile" || _vm.$mq === "tablet"
          ? "navbar-mobile"
          : "navbar-desktop",
        {
          tag: "component",
          attrs: {
            links: _vm.links,
            "tertiary-links": _vm.tertiaryLinks,
            "logged-in": _vm.loggedIn,
            "suggested-searches": _vm.suggestedSearches,
          },
          scopedSlots: _vm._u([
            {
              key: "logo",
              fn: function () {
                return [
                  _c("navbar-logo", {
                    attrs: {
                      image: _vm.logo,
                      "large-image": _vm.logoLarge,
                      alt: _vm.shopName,
                      h1: _vm.h1,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        }
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }